module.exports = __webpack_public_path__ + "img/c54264d57b68c34c33210aa141ffc5c3.svg";